import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  ref: "stackedBar",
  class: "gfu-navbar gfu-navbar--lighter gfu-navbar--elevate _jc-c"
}
const _hoisted_2 = { class: "gfu-navbar-nav gfu-navbar-nav--scrollable gfu-navbar-nav--secondary" }
const _hoisted_3 = ["data-qa"]
const _hoisted_4 = ["data-qa"]
const _hoisted_5 = ["data-qa"]
const _hoisted_6 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "gfu-navbar-nav__wrapper",
        "data-qa": `${$props.dataQaPrefix}-navbar`
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.navigationItems, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.label,
            ref_for: true,
            ref: item.ref,
            class: _normalizeClass(item.classes),
            "data-qa": item.dataQa
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), {
              class: "gfu-navbar-link",
              href: item.href,
              to: item.route
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  class: "gfu-link-underline__content",
                  "data-qa": `${$props.dataQaPrefix}-nav-title`
                }, _toDisplayString(item.label), 9 /* TEXT, PROPS */, _hoisted_5),
                (item.isBadgeVisible)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "gfu-navbar-badge _ml-1",
                      "data-qa": `${$props.dataQaPrefix}-nav-count`
                    }, _toDisplayString(item.number), 9 /* TEXT, PROPS */, _hoisted_6))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["href", "to"]))
          ], 10 /* CLASS, PROPS */, _hoisted_4))
        }), 128 /* KEYED_FRAGMENT */))
      ], 8 /* PROPS */, _hoisted_3)
    ])
  ], 512 /* NEED_PATCH */))
}